import { useEffect } from 'react';
import { useIntersectionObserver } from '@utils/react';
import { scrollDirectionStore } from './scroll-direction.js';

let componentsInView = 0;
function useFixedPM2HeaderWhileRefIsInView(ref, enabled = true) {
  const isInView = useIntersectionObserver(ref);
  useEffect(() => {
    if (!enabled || !isInView) {
      return;
    }
    scrollDirectionStore.dispatch(scrollDirectionStore.actions.forceDirection("down"));
    scrollDirectionStore.dispatch(scrollDirectionStore.actions.setState({
      enabled: false
    }));
    componentsInView++;
    return () => {
      componentsInView--;
      setTimeout(() => {
        if (componentsInView <= 0) {
          scrollDirectionStore.dispatch(scrollDirectionStore.actions.setState({
            enabled: true
          }));
        }
      }, 25);
    };
  }, [enabled, isInView]);
}

export { useFixedPM2HeaderWhileRefIsInView };
//# sourceMappingURL=header-fixed-while-in-view.js.map
